import React, { useContext, useState, useEffect } from 'react'
import { AppContext } from '../../../App'
import HeaderHomeUsers from './../../../components.js/users/homeUsers/HeaderHomeUsers'
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom'
import IdentificationAuth from '../../../components.js/users/authUser/IdentificationAuth'
import useForm from '../../../hooks/useForm'
import useAuthFirebase from '../../../firebase/useAuthFirebase'
import BookingAuth from '../../../components.js/users/authUser/BookingAuth'
import useFirebase from './../../../firebase/useFirebase'
import useHomeUsersPlanning from './../../../hooks/users/useHomeUsersPlanning'
import ModalConfirm from '../../../components.js/modal/ModalConfirm'

const INITIAL_STATE = {
    surname:'',
    name:'',
    email:'',
    password:'',
    phone:'',
} 

const AuthUser = () => {
    const { user } = useContext(AppContext)
    const { handleChange, values } = useForm(INITIAL_STATE)
    const { _signIn, _forgotPassword, _signUp, _signOut } = useAuthFirebase()
    const { updateData, readData, profil, clients, booking } = useFirebase()
    const { _converteTimeToHours } = useHomeUsersPlanning()
    const location = useLocation()
    let navigate = useNavigate() 
    const { state } = location
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const [idResetBooking, setIdResetBooking] = useState()

    useEffect(() => {
        readData(state.keyUid)
        window.scrollTo(0, 0)
    },[])

    const _handleModifInfo = (id,surname,name) => {
        const data = {surname:surname, name:name}
        updateData('entreprises/'+state.keyUid+'/clients/'+id,data)
    }

    const _handleNavigate = () => {
        navigate('/homeUser/'+keyUid+'/'+tokenUser)
    }

    const _handleNavigatePageFilterUserServeur = () => { 
        navigate('/filterUserServeur')
    }

    const _deleteBooking = () => {
        const data = {cancel:true}
        updateData('entreprises/'+keyUid+'/booking/'+idResetBooking,data)
        setIdResetBooking()
    }

    return (
        <div className='container-fluid'>

            {/* ENTETE AVEC ICON LOGIN */}
            <HeaderHomeUsers 
                profil={profil} 
                keyUid={state.keyUid}
                user={user} 
                clients={clients}
            /> 
 
            {user.uid ? 
                <BookingAuth
                    _signOut={_signOut}
                    _handleNavigate={_handleNavigate}
                    booking={booking}
                    user={user}
                    keyUid={keyUid}
                    clients={clients}
                    profil={profil}
                    handleChange={handleChange}
                    values={values}
                    _handleModifInfo={_handleModifInfo}
                    _converteTimeToHours={_converteTimeToHours}
                    setIdResetBooking={setIdResetBooking}
                />
            : 
                <IdentificationAuth
                    values={values}
                    keyUid={state.keyUid}
                    tokenUser={tokenUser}
                    clients={clients}
                    handleChange={handleChange}
                    _signIn={_signIn}
                    _forgotPassword={_forgotPassword}
                    _handleNavigate={_handleNavigate}
                    _signUp={_signUp}
                    _handleNavigatePageFilterUserServeur={_handleNavigatePageFilterUserServeur}
                />
            }

            {/* MODAL CONFIRM */}
            <ModalConfirm
                _handleModal={_deleteBooking}
                title='Êtes-vous sûr de vouloir supprimer le RDV'
            />

            <div style={{ height:400 }} />

        </div>
    )
}

export default AuthUser
